<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
          <app-toolbar [toolbar]="toolbar">
              <ng-template 
                toolbarToolDef="manage_menu" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button 
                        data-cy="splitbutton"
                        class="datex-button splitbutton" 
                        [disabled]="tool.control.readOnly || tool.control.disabled"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matMenuTriggerFor]="dropdownMenuOne"
                        [matTooltip]="tool.control.tooltip">
                  <div class="button-label">
                    <div *ngIf="tool.control.icon"
                          class="button-icon">
                      <i data-cy="splitbutton-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                    <div data-cy="splitbutton-label" class="button-text">{{tool.control.label}}</div>
                    <div class="button-icon splitbutton-drop-icon">
                      <i data-cy="splitbutton-icon" class="icon icon-ic_fluent_chevron_down_20_regular"></i>
                    </div>
                  </div>
                </button>
                <mat-menu #dropdownMenuOne="matMenu" class="options-menu splitbutton-menu">
                  <div data-cy="splitbutton-options">
                    <div *ngIf="!tool.control.buttons.configuration_menu.removed" 
                        mat-menu-item 
                        class="splitbutton-item-container">
                      <button mat-button
                              data-cy="splitbutton-sub-item"
                              class="datex-button splitbutton-sub-item" 
                              [disabled]="tool.control.buttons.configuration_menu.readOnly || tool.control.buttons.configuration_menu.disabled"
                              [ngStyle]="tool.control.buttons.configuration_menu.styles.style"
                              [ngClass]="tool.control.buttons.configuration_menu.styles.classes"
                              [matTooltip]="tool.control.buttons.configuration_menu.tooltip"
                              (click)="on_plc_configurations_clicked($event)">
                        <div class="button-label">
                          <div *ngIf="tool.control.buttons.configuration_menu.icon"
                              class="button-icon">
                            <i data-cy="splitbutton-sub-item-icon" class="icon {{tool.control.buttons.configuration_menu.icon}}"></i>
                          </div>
                          <div data-cy="splitbutton-sub-item-label"
                              class="button-text">{{tool.control.buttons.configuration_menu.label}}</div>
                        </div>
                      </button>
                    </div>
                    <div *ngIf="!tool.control.buttons.zone_mappings.removed" 
                        mat-menu-item 
                        class="splitbutton-item-container">
                      <button mat-button
                              data-cy="splitbutton-sub-item"
                              class="datex-button splitbutton-sub-item" 
                              [disabled]="tool.control.buttons.zone_mappings.readOnly || tool.control.buttons.zone_mappings.disabled"
                              [ngStyle]="tool.control.buttons.zone_mappings.styles.style"
                              [ngClass]="tool.control.buttons.zone_mappings.styles.classes"
                              [matTooltip]="tool.control.buttons.zone_mappings.tooltip"
                              (click)="plc_zone_mappings_clicked($event)">
                        <div class="button-label">
                          <div *ngIf="tool.control.buttons.zone_mappings.icon"
                              class="button-icon">
                            <i data-cy="splitbutton-sub-item-icon" class="icon {{tool.control.buttons.zone_mappings.icon}}"></i>
                          </div>
                          <div data-cy="splitbutton-sub-item-label"
                              class="button-text">{{tool.control.buttons.zone_mappings.label}}</div>
                        </div>
                      </button>
                    </div>
                    <div *ngIf="!tool.control.buttons.message_trace.removed" 
                        mat-menu-item 
                        class="splitbutton-item-container">
                      <button mat-button
                              data-cy="splitbutton-sub-item"
                              class="datex-button splitbutton-sub-item" 
                              [disabled]="tool.control.buttons.message_trace.readOnly || tool.control.buttons.message_trace.disabled"
                              [ngStyle]="tool.control.buttons.message_trace.styles.style"
                              [ngClass]="tool.control.buttons.message_trace.styles.classes"
                              [matTooltip]="tool.control.buttons.message_trace.tooltip"
                              (click)="message_trace_clicked($event)">
                        <div class="button-label">
                          <div *ngIf="tool.control.buttons.message_trace.icon"
                              class="button-icon">
                            <i data-cy="splitbutton-sub-item-icon" class="icon {{tool.control.buttons.message_trace.icon}}"></i>
                          </div>
                          <div data-cy="splitbutton-sub-item-label"
                              class="button-text">{{tool.control.buttons.message_trace.label}}</div>
                        </div>
                      </button>
                    </div>
                    <div *ngIf="!tool.control.buttons.logs.removed" 
                        mat-menu-item 
                        class="splitbutton-item-container">
                      <button mat-button
                              data-cy="splitbutton-sub-item"
                              class="datex-button splitbutton-sub-item" 
                              [disabled]="tool.control.buttons.logs.readOnly || tool.control.buttons.logs.disabled"
                              [ngStyle]="tool.control.buttons.logs.styles.style"
                              [ngClass]="tool.control.buttons.logs.styles.classes"
                              [matTooltip]="tool.control.buttons.logs.tooltip"
                              (click)="on_logs_clicked($event)">
                        <div class="button-label">
                          <div *ngIf="tool.control.buttons.logs.icon"
                              class="button-icon">
                            <i data-cy="splitbutton-sub-item-icon" class="icon {{tool.control.buttons.logs.icon}}"></i>
                          </div>
                          <div data-cy="splitbutton-sub-item-label"
                              class="button-text">{{tool.control.buttons.logs.label}}</div>
                        </div>
                      </button>
                    </div>
                  </div>
                </mat-menu>
                </ng-container>
              </ng-template>
          </app-toolbar>
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
        </div>


        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.tote_groupings.hasTabToShow" class="tab" data-cy="tab-tote_groupings">
              <h2 [className]="tabs.tote_groupings.active? 'active': ''" (click)="tabs.tote_groupings.activate()">{{tabs.tote_groupings.title}}</h2>
            </div>
          </div>
        
              <ProgrammableLogicController-totegroupings_grid *ngIf="tabs.tote_groupings.active"
              #$tabs_tote_groupings
              ($refreshEvent)="refresh(false, false, '$tabs_tote_groupings')">
              </ProgrammableLogicController-totegroupings_grid>
        </div>

      </ng-container>
    </div>
  </div>
</div>